import React, { useState, useEffect, useCallback } from "react";
import { MagicBooks } from "../components/MagicBooks/MagicBooks";
import { Page } from "../components/Page/Page";
import { useServices } from "../services/ServicesProvider";

export function MagicBooksPage(): JSX.Element {
  const { userService } = useServices();
  const [userBalance, setUserBalance] = useState(0);

  useEffect(() => {
    // Get user balance
    const userData = userService?.getUser();
    if (userData) {
      setUserBalance(userData.balance);
    }
  }, [userService]);

  // Callback to handle balance updates after book purchases
  const handleBalanceUpdate = useCallback(
    async (newBalance: number) => {
      // Update local state immediately for instant UI feedback
      setUserBalance(newBalance);

      // Also refresh user data from server to keep it in sync
      // This ensures the balance is accurate for other parts of the app
      if (userService) {
        try {
          await userService.loadUser();
          // Update with the fresh data from server in case of any discrepancies
          const updatedUserData = userService.getUser();
          if (updatedUserData) {
            setUserBalance(updatedUserData.balance);
          }
        } catch (error) {
          console.error(
            "Failed to refresh user data after book purchase:",
            error
          );
          // Keep the local balance update even if server refresh fails
        }
      }
    },
    [userService]
  );

  return (
    <Page>
      <MagicBooks
        userBalance={userBalance}
        onBalanceUpdate={handleBalanceUpdate}
      />
    </Page>
  );
}
